import { render } from "./Dashboard.vue?vue&type=template&id=221fe479&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=221fe479&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-221fe479"

export default script